// Saves only what the applicant typed, never which screen they were on,
// so no one can be reopened onto a screen they can't leave.
import { TRACKS, PACKAGES } from "./masterclassConfig";

const DRAFT_KEY = "mc_draft";
const DRAFT_VERSION = 1; // bump when the form fields change; older drafts are discarded
const MAX_AGE_MS = 3 * 24 * 60 * 60 * 1000; // 3 days

// Leftovers from the old bootcamp form and earlier versions of this form.
const LEGACY_KEYS = ["formData", "verificationStep", "additionalInfo", "mc_form", "mc_step", "mc_payment"];

export const EMPTY_FORM = { fullName: "", email: "", whatsapp: "", track: "", package: "" };

const safe = (fn, fallback) => {
  try {
    return fn();
  } catch {
    return fallback;
  }
};

export const clearAll = () =>
  safe(() => [DRAFT_KEY, ...LEGACY_KEYS].forEach((k) => localStorage.removeItem(k)));

// Runs once on page load: removes old data, and honours the `?reset` support link.
export const prepareStorage = () =>
  safe(() => {
    LEGACY_KEYS.forEach((k) => localStorage.removeItem(k));

    const url = new URL(window.location.href);
    if (url.searchParams.has("reset")) {
      clearAll();
      url.searchParams.delete("reset");
      window.history.replaceState(null, "", url.pathname + url.search + url.hash);
    }
  });

const isValidForm = (f) =>
  f &&
  typeof f === "object" &&
  ["fullName", "email", "whatsapp", "track", "package"].every((k) => typeof f[k] === "string") &&
  (f.track === "" || TRACKS.some((t) => t.id === f.track)) &&
  (f.package === "" || PACKAGES.some((p) => p.id === f.package));

export const loadDraft = () =>
  safe(() => {
    const raw = localStorage.getItem(DRAFT_KEY);
    if (!raw) return EMPTY_FORM;
    const draft = JSON.parse(raw);
    const fresh = draft?.version === DRAFT_VERSION && Date.now() - draft.savedAt < MAX_AGE_MS;
    if (fresh && isValidForm(draft.form)) return { ...EMPTY_FORM, ...draft.form };
    localStorage.removeItem(DRAFT_KEY);
    return EMPTY_FORM;
  }, EMPTY_FORM);

export const saveDraft = (form) =>
  safe(() => {
    const isEmpty = Object.values(form).every((v) => !v);
    if (isEmpty) return localStorage.removeItem(DRAFT_KEY);
    localStorage.setItem(DRAFT_KEY, JSON.stringify({ version: DRAFT_VERSION, savedAt: Date.now(), form }));
  });
